import { combineReducers } from "redux"
import stateTransitions from "store/modules/entities/overview/stateTransitions"

import { createReducer } from "store/helpers/reducers"
import {
  UPDATE,
  CREATE
} from "store/modules/entities/overview/stateTransitions"
import cardDetails from "store/modules/entities/overview/orderDetails"
import comments from "store/modules/entities/overview/comments"
import billingAddresses from "store/modules/entities/overview/billingAddresses"
import assets from "store/modules/entities/overview/assets"
import {
  UPDATE_MARKED_SUCCESS,
  UPDATE_SUCCESS
} from "store/modules/entities/order"

const initialByIds = {}
const byId = createReducer(initialByIds, {
  [UPDATE]: (state, action) => {
    const { order: oneOrder, orders } = action.payload
    const order = oneOrder ?? orders[0]
    return {
      ...state,
      [order.id.toString()]: { ...order, id: order.id.toString() }
    }
  },
  [CREATE]: (state, action) => {
    const { order } = action.payload
    return {
      ...state,
      [order.id.toString()]: { ...order, id: order.id.toString() }
    }
  },
  [UPDATE_SUCCESS]: (state, action) => {
    const { order } = action.payload
    return {
      ...state,
      [order.id.toString()]: { ...state[order.id], ...order }
    }
  },
  [UPDATE_MARKED_SUCCESS]: (state, action) => {
    const {
      order: { order } // Don't ask ;(
    } = action.result
    return {
      ...state,
      [order.id.toString()]: { ...state[order.id], ...order }
    }
  }
})

export default combineReducers({
  byId,
  stateTransitions,
  cardDetails,
  comments,
  billingAddresses,
  assets
})
